function render( dateCreated: string ) {
	const parsedDate = new Date( dateCreated )
	return parsedDate.toLocaleDateString( 'en-US' )
}

export default {
	field: 'dateCreated',
	name: 'Date',
	render,
	width: '110px',
}
